/**
 * Product PDF Export - Single-product spec-sheet download from the product page.
 *
 * @ui @pdf @product @staff-tool
 *
 * Opens the #product-pdf-overlay modal, lets the customer toggle which
 * sections to include, shows a live HTML preview, and downloads a branded
 * single-product PDF. The backend reuses the portal project-PDF pipeline.
 *
 * Backend (Shopify app proxy):
 *   GET /apps/trade-program/product-pdf/preview?handle=...&show_*=0|1
 *   GET /apps/trade-program/product-pdf/download?handle=...&show_*=0|1
 *
 * Product context is injected by product-pdf-modal.liquid as
 *   window.__sgiPdfProduct = { handle, title, allowPrice }
 *
 * See Also: product-pdf-modal.liquid
 */
(function () {
  'use strict';

  var API_BASE = '/apps/trade-program/product-pdf';
  // Option ids map 1:1 to backend show_<id> query params.
  var OPTION_IDS = ['price', 'qr', 'dimensions', 'material', 'weight_coverage', 'packaging', 'usage'];
  var previewTimer = null;

  function _product() { return window.__sgiPdfProduct || null; }
  function _overlay() { return document.getElementById('product-pdf-overlay'); }

  function _buildParams() {
    var p = _product() || {};
    var params = new URLSearchParams();
    if (p.handle) params.set('handle', p.handle);
    OPTION_IDS.forEach(function (id) {
      var el = document.getElementById('ppdf-opt-' + id);
      // A missing checkbox (e.g. price hidden because sgi-price-mode resolved the
      // product to mode 'hide_price' or 'quote') => off.
      params.set('show_' + id, el && el.checked ? '1' : '0');
    });
    return params;
  }

  function refreshPreview() {
    var iframe = document.getElementById('ppdf-preview');
    if (!iframe) return;
    var status = document.getElementById('ppdf-preview-status');
    if (status) status.style.display = 'flex';
    iframe.onload = function () { if (status) status.style.display = 'none'; };
    iframe.src = API_BASE + '/preview?' + _buildParams().toString();
  }

  function _debouncedPreview() {
    if (previewTimer) clearTimeout(previewTimer);
    previewTimer = setTimeout(refreshPreview, 250);
  }

  function openProductPdfModal() {
    var overlay = _overlay();
    if (!overlay) return;
    var p = _product();
    if (!p || !p.handle) {
      alert('Product information is unavailable for PDF export.');
      return;
    }
    overlay.style.display = 'flex';
    document.body.style.overflow = 'hidden';
    refreshPreview();
  }

  function closeProductPdfModal() {
    var overlay = _overlay();
    if (!overlay) return;
    overlay.style.display = 'none';
    document.body.style.overflow = '';
  }

  function downloadProductPdf() {
    var btn = document.getElementById('ppdf-download-btn');
    var p = _product() || {};
    if (btn) { btn.disabled = true; btn.textContent = 'Generating…'; }
    fetch(API_BASE + '/download?' + _buildParams().toString())
      .then(function (res) {
        if (!res.ok) throw new Error('PDF generation failed (' + res.status + ')');
        return res.blob();
      })
      .then(function (blob) {
        var url = URL.createObjectURL(blob);
        var a = document.createElement('a');
        a.href = url;
        a.download = (p.title ? p.title.replace(/[^\w\-]+/g, '_') : 'product') + '_spec_sheet.pdf';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
      })
      .catch(function (e) {
        console.error('[product-pdf]', e);
        alert('Sorry, the PDF could not be generated. Please try again.');
      })
      .finally(function () {
        if (btn) { btn.disabled = false; btn.textContent = 'Download PDF'; }
      });
  }

  function _init() {
    var overlay = _overlay();
    if (!overlay) return;
    // Close on backdrop click.
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) closeProductPdfModal();
    });
    // Close on Escape.
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && overlay.style.display === 'flex') closeProductPdfModal();
    });
    // Re-render the preview whenever an option changes.
    overlay.querySelectorAll('input[type="checkbox"]').forEach(function (cb) {
      cb.addEventListener('change', _debouncedPreview);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', _init);
  } else {
    _init();
  }

  // Expose globals for the Custom Liquid button + modal controls.
  window.openProductPdfModal = openProductPdfModal;
  window.closeProductPdfModal = closeProductPdfModal;
  window.downloadProductPdf = downloadProductPdf;
  window.refreshProductPdfPreview = refreshPreview;
})();
